import { FunctionalComponent, h } from '@stencil/core';
import filter from 'lodash/filter'
import { AppListItem, AppSpecificationsMatrix } from '.';

interface SectionProductDetails {
    __component?: string;
    data?: any;
}


export const SectionProductDetails: FunctionalComponent<SectionProductDetails> = ({data}) => {

    const { Title, Subtitle, SpecificationLabel, Specifications, OptionalItems, NewsLabel, News} = data;

    // Optional Tabs
    const tabs = OptionalItems.map(item => item.Type).filter((value, index, self) => self.indexOf(value) === index);

    return (
        <section class="uk-section uk-padding-remove-top">
            <div class="uk-container">
                <div>
                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
                    <h3 class="uk-heading-xlarge uk-margin-remove-top wsio-darker-green uk-width-1-1">{Title}</h3>
                </div>
                <div class="uk-margin-medium-top">

                    <ul class="uk-flex-nowrap uk-overflow-auto"  uk-tab>
                        <li><a href="#" rel="nofollow">{SpecificationLabel}</a></li>
                        {tabs.map((tab) => <li><a href="#" rel="nofollow" >{tab}</a></li>)}
                        <li>{News.data.length > 0 ? <a href="#" rel="nofollow" >{NewsLabel}</a> : ''}</li>
                    </ul>

                    {/* <ul class="uk-hidden@s uk-tab-right" uk-tab="media: 0">
                        <li><a href="#" rel="nofollow" >{SpecificationLabel}</a></li>
                        {tabs.map((tab) => <li><a href="#" rel="nofollow" >{tab}</a></li>)}
                        <li>{News.data.length > 0 ? <a href="#" rel="nofollow" >{NewsLabel}</a> : ''}</li>
                    </ul> */}

                    <ul id="switcher-container" class="uk-margin uk-switcher" uk-switcher="connect: #switcher-container; swiping:true;">
                        <li>
                            <div>
                                <AppSpecificationsMatrix Specifications={Specifications}/>
                            </div>
                        </li>
                        {(tabs.map((tab)=> 
                        <li class="uk-margin-medium-top">
                                {filter(OptionalItems, { Type: tab }).map(({ Title, Description, Media }) => <AppListItem Media={Media} Title={Title} Description={Description}/>)}
                        </li>
                        ))}
                        <li class="uk-margin-medium-top">
                            {News.data.map(({ attributes }) => { 
                                const { Title, Media, Description, Slug } = attributes;
                                const Link = { Alt: Title, Label: 'View Article', URL: `/news/${Slug}`}
                                return <AppListItem Media={Media} Title={Title} Description={Description} Link={Link} />
                            })}
                        </li>
                    </ul>
                </div>
            </div>
        </section>

    )
};